import React, { ReactNode } from 'react';
import { Controller } from 'react-hook-form';

import { InfoIcon } from '../../assets/icons';
import { ITextareaProps, Textarea, Tooltip } from '../../components';
import { FormError } from '../FormError';
import { FormField } from '../FormField';
import { FormLabel } from '../FormLabel';

import styles from './TextareaField.module.scss';

export interface ITextareaFieldProps extends ITextareaProps {
    name: string;
    label?: string;
    labelInfo?: ReactNode;
}

export const TextareaField: React.FC<ITextareaFieldProps> = ({ id, name, label, labelInfo, ...inputProps }) => {
    return (
        <Controller
            name={name}
            render={({ field: { onChange, ...fieldProps }, fieldState: { error } }) => (
                <FormField
                    labelSlot={
                        label && (
                            <span className={styles.labelRow}>
                                <FormLabel htmlFor={id || name}>{label}</FormLabel>
                                {labelInfo && (
                                    <Tooltip content={labelInfo}>
                                        <span className={styles.infoIcon}>
                                            <InfoIcon width={16} height={16} />
                                        </span>
                                    </Tooltip>
                                )}
                            </span>
                        )
                    }
                    errorSlot={error && <FormError>{error?.message}</FormError>}
                >
                    <Textarea
                        id={id || name}
                        error={!!error}
                        onChange={(e) => {
                            const value = e.target.value;
                            onChange(value);
                        }}
                        {...fieldProps}
                        {...inputProps}
                    />
                </FormField>
            )}
        />
    );
};
